export const kimpleFolderColor = {
  0: {
    position: 1,
    color: '#7676DF'
  },
  1: {
    position: 2,
    color: '#EC6271'
  },
  2: {
    position: 3,
    color: '#F19E65'
  }
}
